import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";

export const removeQuoteConcept = (id_quote_concept: number) => {
   return apiClient<ApiResponse>(`/v1/quote/concept/${id_quote_concept}`, {
      method: "DELETE",
   })
}
